import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { gpsSelector } from '../../selectors/gps';
import { getGpsStatusesRequest, getGpsSubstatusRequest, getExportGpsRequest, closePingEventExportGps, getGpsDevicesRequest } from '../../actions/gps';
import { setGpsFilters } from '../../actions/filters';
import { filtersGpsSelector, filtersGpsToUseInQuerySelector } from '../../selectors/filters';
import FilterGps from './FilterGps';

const mapStateToProps = createStructuredSelector({
    gps: gpsSelector,
    filters: filtersGpsSelector,
    filtersToUseInQuery: filtersGpsToUseInQuerySelector
});

const mapDispatchToProps = {
    getGpsStatusesRequest,
    getGpsSubstatusRequest,
    setGpsFilters,
    getExportGpsRequest,
    closePingEventExportGps,
    getGpsDevicesRequest
};

export default connect(mapStateToProps, mapDispatchToProps)(FilterGps);
